export default class MaterialManager {

  constructor (json, baseURL = '/') {
    this.json = json;

    this.materials = {
      0: this.create({
        roughness: 0.5,
        metalness: 0,
        map: baseURL + 'static/textures/sbs/albedo.png',
        normalMap: baseURL + 'static/textures/sbs/normal.png',
        roughnessMap: baseURL + 'static/textures/sbs/roughness.png'
      }),
      1: this.create({
        roughness: 0,
        metalness: 1,
        map: baseURL + 'static/textures/metal/shkafchc_2K_Albedo.jpg',
        normalMap: baseURL + 'static/textures/metal/shkafchc_2K_Normal.jpg',
        roughnessMap: baseURL + 'static/textures/metal/shkafchc_2K_Roughness.jpg'
      }),
      2: this.create({
        roughness: 1,
        metalness: 0,
        map: baseURL + 'static/textures/mdf/mdf_2K_Color.jpg',
        normalMap: baseURL + 'static/textures/mdf/mdf_2K_Normal.jpg',
        roughnessMap: baseURL + 'static/textures/mdf/mdf_2K_Roughness.jpg'
      })
    };
  }

  use (id) {
    if (!(id in this.materials)) {
      const source = this.json.find(mat => mat.id === id);
      if (source !== undefined && source.texture !== undefined) {
        const m = this.create(source.texture);
        this.materials[id] = m;
      }
    }
    return this.materials[id];
  }

  create (texture, scale = 0.002) {
    const callback = (t) => {
      t.repeat.set(scale, scale);
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
    };
    const { map, normalMap, roughnessMap, roughness, metalness } = texture;
    return new THREE.MeshStandardMaterial({
      side: THREE.DoubleSide,
      roughness: roughness,
      metalness: metalness,
      map: new THREE.TextureLoader().load(map, callback),
      normalMap: new THREE.TextureLoader().load(normalMap, callback),
      roughnessMap: new THREE.TextureLoader().load(roughnessMap, callback)
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/manager/MaterialManager.js